import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Modal, Popconfirm, message, Tooltip } from "antd";
import { PlusOutlined, EditOutlined, DiffOutlined, DeleteOutlined } from "@ant-design/icons";
import "bootstrap/dist/css/bootstrap.min.css";
import FormularioCohorte from "./FormularioCohorte";
import { getCohorte, deleteCohorte } from "../../../../services/Producto_3/Uniminuto/uniminutosServices"
import ExportToExcelCohortes from "./ExcelCohortes"
import ExcelDetalleCohorte from "./ExcelDetalleCohorte"
import "./Uniminuto.css"


const Uniminuto = () => {

    const modalRef = useRef();
    const [data, setData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [fullText, setFullText] = useState("");
    const [indicadores, setIndicadores] = useState({
        numCohortes: 0,
        numSesionesVirtuales: 0,
        numSesionesAutonomas: 0,
        numSesionesPresenciales: 0,
        totalParticipantesPresenciales: 0,
        totalParticipantesVirtuales: 0,
        totalParticipantesAutonomas: 0,
        porc_Htot: 0,
        porc_Mtot: 0,
        participacionMujeresPresenciales: 0,
        participacionHombresPresenciales: 0,
        participacionMujeresVirtuales: 0,
        participacionHombresVirtuales: 0,
        participacionMujeresAutonomas: 0,
        participacionHombresAutonomas: 0,
        numSesiones: 0,
        asistentesHombres: 0,
        asistentesMujeres: 0,
        asistentesHombresV: 0,
        asistentesMujeresV: 0,
        porc_asistentesHombresV: 0,
        porc_asistentesMujeresV: 0,
        asistentesHombresP: 0,
        asistentesMujeresP: 0,
        porc_asistentesHombresP: 0,
        porc_asistentesMujeresP: 0,
        asistentesHombresA: 0,
        asistentesMujeresA: 0,
        porc_asistentesHombresA: 0,
        porc_asistentesMujeresA: 0,
    });

    const fetchData = async () => {
        try {
            const response = await getCohorte();
            if (response.status === 200 && response.success) {
                // Transformamos los datos para la tabla
                const transformedData = response.data.map((reg) => {
                    const jsonData = reg.JSONDataCohorte;
                    const sesiones = jsonData.detalleSesiones || [];
                    const sesionesVirtuales = sesiones.filter(s => s.modalidadSesion === "Virtual" && s.numSesion != null);
                    const numSesionesUnicasVirtuales = new Set(sesionesVirtuales.map(s => s.numSesion));
                    const totalNumSesionVirtual = numSesionesUnicasVirtuales.size;
                    const sesionesAutonomas = sesiones.filter(s => s.modalidadSesion === "Autónomo" && s.numSesion != null);
                    const numSesionesUnicasAutonomas = new Set(sesionesAutonomas.map(s => s.numSesion));
                    const totalNumSesionAutonomas = numSesionesUnicasAutonomas.size;
                    const sesionesPresenciales = sesiones.filter(s => s.modalidadSesion === "Presencial" && s.numSesion != null);
                    const numSesionesUnicasPresenciales = new Set(sesionesPresenciales.map(s => s.numSesion));
                    const totalNumSesionPresenciale = numSesionesUnicasPresenciales.size;
                    const numSesiones = totalNumSesionVirtual + totalNumSesionAutonomas + totalNumSesionPresenciale;
                    const totalAsistentes =
                        sesionesVirtuales.reduce((acc, ses) => acc + Number(ses.asistentes || 0), 0) +
                        sesionesAutonomas.reduce((acc, ses) => acc + Number(ses.asistentes || 0), 0) +
                        sesionesPresenciales.reduce((acc, ses) => acc + Number(ses.asistentes || 0), 0);
                    const asistentesHombres = sesionesVirtuales.reduce(
                        (acc, ses) => acc + Number(ses.hombres || 0),
                        0
                    ) + sesionesAutonomas.reduce(
                        (acc, ses) => acc + Number(ses.hombres || 0),
                        0
                    ) + sesionesPresenciales.reduce(
                        (acc, ses) => acc + Number(ses.hombres || 0),
                        0
                    );
                    const asistentesMujeres = sesionesVirtuales.reduce(
                        (acc, ses) => acc + Number(ses.mujeres || 0),
                        0
                    ) + sesionesAutonomas.reduce(
                        (acc, ses) => acc + Number(ses.mujeres || 0),
                        0
                    ) + sesionesPresenciales.reduce(
                        (acc, ses) => acc + Number(ses.mujeres || 0),
                        0
                    );
                    // Calculamos los totales específicos para cada tipo de sesión
                    const asistentesHombresP = sesionesPresenciales.reduce((acc, ses) => acc + Number(ses.hombres || 0), 0);
                    const asistentesMujeresP = sesionesPresenciales.reduce((acc, ses) => acc + Number(ses.mujeres || 0), 0);
                    const asistentesHombresV = sesionesVirtuales.reduce((acc, ses) => acc + Number(ses.hombres || 0), 0);
                    const asistentesMujeresV = sesionesVirtuales.reduce((acc, ses) => acc + Number(ses.mujeres || 0), 0);
                    const asistentesHombresA = sesionesAutonomas.reduce((acc, ses) => acc + Number(ses.hombres || 0), 0);
                    const asistentesMujeresA = sesionesAutonomas.reduce((acc, ses) => acc + Number(ses.mujeres || 0), 0);
                    const totalPV = asistentesHombresV + asistentesMujeresV;
                    const porcentajeHombresV = totalPV > 0 ? ((asistentesHombresV / totalPV) * 100).toFixed(2) : "0.00";
                    const porcentajeMujeresV = totalPV > 0 ? ((asistentesMujeresV / totalPV) * 100).toFixed(2) : "0.00";
                    const totalPA = asistentesHombresA + asistentesMujeresA;
                    const porcentajeHombresA = totalPA > 0 ? ((asistentesHombresA / totalPA) * 100).toFixed(2) : "0.00";
                    const porcentajeMujeresA = totalPA > 0 ? ((asistentesMujeresA / totalPA) * 100).toFixed(2) : "0.00";
                    const porcentajeasistentesHombres =
                        totalAsistentes > 0
                            ? ((asistentesHombres / totalAsistentes) * 100).toFixed(2)
                            : "0.00";
                    const porcentajeasistentesMujeres =
                        totalAsistentes > 0
                            ? ((asistentesMujeres / totalAsistentes) * 100).toFixed(2)
                            : "0.00";
                    // Porcentajes por tipo de sesión
                    const calcularPorcentaje = (total, valor) => (total > 0 ? ((valor / total) * 100).toFixed(2) : "0.00");
                    const porcentajeHombresP = calcularPorcentaje(asistentesHombresP + asistentesMujeresP, asistentesHombresP);
                    const porcentajeMujeresP = calcularPorcentaje(asistentesHombresP + asistentesMujeresP, asistentesMujeresP);
                    return {
                        key: reg.oid.toString(),
                        cohorte: jsonData.cohorte,
                        resumen: jsonData.resumen,
                        numSesiones,
                        totalAsistentes,
                        asistentesHombres,
                        asistentesMujeres,
                        porcentajeasistentesHombres,
                        porcentajeasistentesMujeres,
                        numSesionesVirtuales: totalNumSesionVirtual,
                        numSesionesAutonomas: totalNumSesionAutonomas,
                        numSesionesPresenciales: totalNumSesionPresenciale,  // ✅ Agregar esto
                        // Agregar datos de sesiones presenciales
                        asistentesHombresP,
                        asistentesMujeresP,
                        porc_asistentesHombresP: porcentajeHombresP,
                        porc_asistentesMujeresP: porcentajeMujeresP,
                        // Agregamos los nuevos campos:
                        asistentesHombresV,
                        asistentesMujeresV,
                        porc_asistentesHombresV: porcentajeHombresV,
                        porc_asistentesMujeresV: porcentajeMujeresV,
                        asistentesHombresA,
                        asistentesMujeresA,
                        porc_asistentesHombresA: porcentajeHombresA,
                        porc_asistentesMujeresA: porcentajeMujeresA,
                        rawData: reg,
                    };
                });
                setData(transformedData);
                // Calculamos los indicadores globales a partir de la respuesta original
                let global = {
                    numCohortes: 0,
                    // Número de sesiones por tipo
                    numSesionesVirtuales: 0,
                    numSesionesAutonomas: 0,
                    numSesionesPresenciales: 0,
                    numSesiones: 0,
                    // Total de participantes por tipo de sesión
                    totalParticipantesVirtuales: 0,
                    totalParticipantesAutonomas: 0,
                    totalParticipantesPresenciales: 0,
                    // Totales de asistentes por género
                    asistentesHombres: 0,
                    asistentesMujeres: 0,
                    // Totales de asistentes por género en cada tipo de sesión
                    sumaHombresVirtuales: 0,
                    sumaMujeresVirtuales: 0,
                    sumaHombresAutonomas: 0,
                    sumaMujeresAutonomas: 0,
                    sumaHombresPresenciales: 0,
                    sumaMujeresPresenciales: 0,
                    // Porcentajes de asistentes por género
                    porcentajeasistentesHombres: 0,
                    porcentajeasistentesMujeres: 0,
                    porcentajeasistentesHombresV: 0,
                    porcentajeasistentesMujeresV: 0,
                    porcentajeasistentesHombresA: 0,
                    porcentajeasistentesMujeresA: 0,
                    porcentajeasistentesHombresP: 0,
                    porcentajeasistentesMujeresP: 0,
                };

                response.data.forEach((reg) => {
                    global.numCohortes += 1;
                    const jsonData = reg.JSONDataCohorte;
                    // Filtrar sesiones por tipo
                    const sesionesVirtuales = jsonData.detalleSesiones.filter(sesion => sesion.modalidadSesion === "Virtual" && sesion.numSesion != null) || [];
                    const numSesionesUnicasVirtuales = new Set(sesionesVirtuales.map(s => s.numSesion));
                    const totalNumSesionVirtual = numSesionesUnicasVirtuales.size;
                    const sesionesAutonomas = jsonData.detalleSesiones.filter(sesion => sesion.modalidadSesion === "Autónomo" && sesion.numSesion != null) || [];
                    const numSesionesUnicasAutonomas = new Set(sesionesAutonomas.map(s => s.numSesion));
                    const totalNumSesionAutonomas = numSesionesUnicasAutonomas.size;
                    const sesionesPresenciales = jsonData.detalleSesiones.filter(sesion => sesion.modalidadSesion === "Presencial" && sesion.numSesion != null) || [];
                    const numSesionesUnicasPresenciales = new Set(sesionesPresenciales.map(s => s.numSesion));
                    const totalNumSesionPresenciale = numSesionesUnicasPresenciales.size;
                    // Sumar número de sesiones por tipo
                    global.numSesionesVirtuales += totalNumSesionVirtual;
                    global.numSesionesAutonomas += totalNumSesionAutonomas;
                    global.numSesionesPresenciales += totalNumSesionPresenciale;
                    // Sumar total de asistentes por tipo de sesión
                    global.totalParticipantesVirtuales += sesionesVirtuales.reduce((acc, ses) => acc + Number(ses.asistentes || 0), 0);
                    global.totalParticipantesAutonomas += sesionesAutonomas.reduce((acc, ses) => acc + Number(ses.asistentes || 0), 0);
                    global.totalParticipantesPresenciales += sesionesPresenciales.reduce((acc, ses) => acc + Number(ses.asistentes || 0), 0);
                    // Sumar asistentes hombres y mujeres en cada tipo de sesión
                    global.sumaHombresVirtuales += sesionesVirtuales.reduce((acc, ses) => acc + Number(ses.hombres || 0), 0);
                    global.sumaMujeresVirtuales += sesionesVirtuales.reduce((acc, ses) => acc + Number(ses.mujeres || 0), 0);
                    global.sumaHombresAutonomas += sesionesAutonomas.reduce((acc, ses) => acc + Number(ses.hombres || 0), 0);
                    global.sumaMujeresAutonomas += sesionesAutonomas.reduce((acc, ses) => acc + Number(ses.mujeres || 0), 0);
                    global.sumaHombresPresenciales += sesionesPresenciales.reduce((acc, ses) => acc + Number(ses.hombres || 0), 0);
                    global.sumaMujeresPresenciales += sesionesPresenciales.reduce((acc, ses) => acc + Number(ses.mujeres || 0), 0);
                });

                // Calcula totales adicionales
                global.numSesiones = global.numSesionesVirtuales + global.numSesionesAutonomas + global.numSesionesPresenciales;
                global.asistentesHombres = global.sumaHombresVirtuales + global.sumaHombresAutonomas + global.sumaHombresPresenciales;
                global.asistentesMujeres = global.sumaMujeresVirtuales + global.sumaMujeresAutonomas + global.sumaMujeresPresenciales;
                // Calcula totales y porcentajes
                const totalVirtuales = global.totalParticipantesVirtuales;
                const totalAutonomas = global.totalParticipantesAutonomas;
                const totalPresenciales = global.totalParticipantesPresenciales;
                const totalParticipantes = totalVirtuales + totalAutonomas + totalPresenciales;
                const calcularPorcentaje = (total, valor) => (total > 0 ? ((valor / total) * 100).toFixed(2) : "0.00");
                // Participación en sesiones virtuales
                const participacionHombresVirtuales = calcularPorcentaje(totalVirtuales, global.sumaHombresVirtuales);
                const participacionMujeresVirtuales = calcularPorcentaje(totalVirtuales, global.sumaMujeresVirtuales);
                // Participación en sesiones autónomas
                const participacionHombresAutonomas = calcularPorcentaje(totalAutonomas, global.sumaHombresAutonomas);
                const participacionMujeresAutonomas = calcularPorcentaje(totalAutonomas, global.sumaMujeresAutonomas);
                // Participación en sesiones presenciales
                const participacionHombresPresenciales = calcularPorcentaje(totalPresenciales, global.sumaHombresPresenciales);
                const participacionMujeresPresenciales = calcularPorcentaje(totalPresenciales, global.sumaMujeresPresenciales);
                // Porcentaje total de asistentes hombres y mujeres en todas las sesiones
                const porcentajeasistentesHombres = calcularPorcentaje(totalParticipantes, global.asistentesHombres);
                const porcentajeasistentesMujeres = calcularPorcentaje(totalParticipantes, global.asistentesMujeres);
                // Asignar valores al estado
                setIndicadores({
                    numCohortes: global.numCohortes,
                    numSesionesVirtuales: global.numSesionesVirtuales,
                    numSesionesAutonomas: global.numSesionesAutonomas,
                    numSesionesPresenciales: global.numSesionesPresenciales,
                    numSesiones: global.numSesiones,
                    totalParticipantesVirtuales: totalVirtuales,
                    totalParticipantesAutonomas: totalAutonomas,
                    totalParticipantesPresenciales: totalPresenciales,
                    asistentesHombres: global.asistentesHombres,
                    asistentesMujeres: global.asistentesMujeres,
                    participacionHombresVirtuales: Number(participacionHombresVirtuales),
                    participacionMujeresVirtuales: Number(participacionMujeresVirtuales),
                    participacionHombresAutonomas: Number(participacionHombresAutonomas),
                    participacionMujeresAutonomas: Number(participacionMujeresAutonomas),
                    participacionHombresPresenciales: Number(participacionHombresPresenciales),
                    participacionMujeresPresenciales: Number(participacionMujeresPresenciales),
                    asistentesHombresV: global.sumaHombresVirtuales,
                    asistentesMujeresV: global.sumaMujeresVirtuales,
                    asistentesHombresA: global.sumaHombresAutonomas,
                    asistentesMujeresA: global.sumaMujeresAutonomas,
                    asistentesHombresP: global.sumaHombresPresenciales,
                    asistentesMujeresP: global.sumaMujeresPresenciales,
                    porc_asistentesHombresV: participacionHombresVirtuales,
                    porc_asistentesMujeresV: participacionMujeresVirtuales,
                    porc_asistentesHombresA: participacionHombresAutonomas,
                    porc_asistentesMujeresA: participacionMujeresAutonomas,
                    porc_asistentesHombresP: participacionHombresPresenciales,
                    porc_asistentesMujeresP: participacionMujeresPresenciales,
                    porc_Htot: porcentajeasistentesHombres,
                    porc_Mtot: porcentajeasistentesMujeres,
                });
            } else {
                message.error("Error en la consulta de cohortes");
            }
        } catch (error) {
            console.error("Error fetching cohortes:", error);
            message.error("Error al obtener cohortes");
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    const handleDelete = async (record, userLogin) => {
        try {
            const userName = modalRef.current?.userLogin;
            if (userName === undefined) {
                message.warning("Debe iniciar sesión nuevamente.");
                return;
            }
            const oid = record.key; // Suponiendo que "key" es el oid
            const registroActual = record.rawData; // Guardamos los datos actuales antes de eliminar
            await deleteCohorte(userName, oid, registroActual);
            message.success("Cohorte eliminado correctamente");
            // Refrescamos los datos después de eliminar
            fetchData();
        } catch (error) {
            message.error("Error al eliminar el cohorte");
        }
    };
    // Columnas de la tabla
    const columns = [
        {
            title: "Acciones",
            key: "acciones",
            align: "center",
            width: 150,
            fixed: 'left',
            className: 'ajustecolumna',
            render: (text, record) => (
                <>
                    {modalRef.current?.permissionUpdate && (

                        <Button type="primary" icon={<EditOutlined />} onClick={() => handleEdit(record)}>

                        </Button>

                    )}

                    {modalRef.current?.permissionDelete && (

                        <Popconfirm
                            title="¿Estás seguro de eliminar el registro de cohorte?"
                            onConfirm={() => handleDelete(record)}
                            okText="Sí"
                            cancelText="No"
                            placement="topRight"
                        >
                            <Button
                                danger
                                icon={<DeleteOutlined />}
                                style={{ marginLeft: '10px' }} >

                            </Button>
                        </Popconfirm>
                    )}

                    {modalRef.current?.permissionPrint && (
                        <ExcelDetalleCohorte cohorte={record} />
                    )}
                </>
            ),
        },
        {
            title: "Cohorte",
            dataIndex: "cohorte",
            key: "cohorte",
            width: 90,
            render: (text) => (
                <Tooltip title={text}>
                    <span>{text && text.length > 20 ? text.slice(0, 20) + "..." : text}</span>
                </Tooltip>
            ),
        },

        {
            title: "Resumen",
            dataIndex: "resumen",
            key: "resumen",
            width: 170,
            render: (text) => (
                <>
                    <DiffOutlined style={{ color: "#1890ff", fontSize: "16px", marginRight: "8px", cursor: "pointer" }} onClick={() => openModal(text)} />
                    {text && text.length > 30 ? text.slice(0, 30) + "..." : text}
                </>
            ),
        },

        {
            title: "Sesiones",
            className: "custom-header-sesiones",
            children: [
                {
                    title: "Total sesiones",
                    dataIndex: "numSesiones",
                    key: "numSesiones",
                    align: "center",
                    className: "ajustecolumna",
                    width: 120,
                },
                {
                    title: "Presenciales",
                    dataIndex: "numSesionesPresenciales",
                    key: "numSesionesPresenciales",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },
                {
                    title: "Virtuales",
                    dataIndex: "numSesionesVirtuales",
                    key: "numSesionesVirtuales",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },
                {
                    title: "Autonomas",
                    dataIndex: "numSesionesAutonomas",
                    key: "numSesionesAutonomas",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },
            ],
        },
        {
            title: "Consolidado participación",
            className: "custom-header-participacion",
            children: [
                {
                    title: "Total Asistentes",
                    dataIndex: "totalAsistentes",
                    key: "totalAsistentes",
                    align: "center",
                    className: "ajustecolumna",
                    width: 150,
                },
                {
                    title: "Hombres",
                    dataIndex: "asistentesHombres",
                    key: "asistentesHombres",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },
                {
                    title: "Mujeres",
                    dataIndex: "asistentesMujeres",
                    key: "asistentesMujeres",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                    
                },
                {
                    title: "% Hombres",
                    dataIndex: "porcentajeasistentesHombres",
                    key: "porcentajeasistentesHombres",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },
                {
                    title: "% Mujeres",
                    dataIndex: "porcentajeasistentesMujeres",
                    key: "porcentajeasistentesMujeres",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },
            ],
        },

        {
            title: "Participación sesiones presenciales",
            className: "custom-header-participacion-sesionesP",
            children: [

                {
                    title: "Asistentes Hombres",
                    dataIndex: "asistentesHombresP",
                    key: "asistentesHombresP",
                    align: "center",
                    className: "ajustecolumna",
                    width: 150,
                },
                {
                    title: "% Hombres",
                    dataIndex: "porc_asistentesHombresP",
                    key: "porc_asistentesHombresP",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },

                {
                    title: "Asistentes Mujeres",
                    dataIndex: "asistentesMujeresP",
                    key: "asistentesMujeresP",
                    align: "center",
                    className: "ajustecolumna",
                    width: 150,
                },

                {
                    title: "% Mujeres",
                    dataIndex: "porc_asistentesMujeresP",
                    key: "porc_asistentesMujeresV",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },

            ],
        },

        {
            title: "Participación sesiones virtuales",
            className: "custom-header-participacion-sesionesV",
            children: [

                {
                    title: "Asistentes Hombres",
                    dataIndex: "asistentesHombresV",
                    key: "asistentesHombresV",
                    align: "center",
                    className: "ajustecolumna",
                    width: 150,
                },
                {
                    title: "% Hombres",
                    dataIndex: "porc_asistentesHombresV",
                    key: "porc_asistentesHombresV",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },

                {
                    title: "Asistentes Mujeres",
                    dataIndex: "asistentesMujeresV",
                    key: "asistentesMujeresV",
                    align: "center",
                    className: "ajustecolumna",
                    width: 150,
                },

                {
                    title: "% Mujeres",
                    dataIndex: "porc_asistentesMujeresV",
                    key: "porc_asistentesMujeresV",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },

            ],
        },

        {
            title: "Participación sesiones Autonomas",
            className: "custom-header-participacion-sesionesA",
            children: [

                {
                    title: "Asistentes Hombres",
                    dataIndex: "asistentesHombresA",
                    key: "asistentesHombresA",
                    align: "center",
                    className: "ajustecolumna",
                    width: 150,
                },
                {
                    title: "% Hombres",
                    dataIndex: "porc_asistentesHombresA",
                    key: "porc_asistentesHombresA",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },
                {
                    title: "Asistentes Mujeres",
                    dataIndex: "asistentesMujeresA",
                    key: "asistentesMujeresA",
                    align: "center",
                    className: "ajustecolumna",
                    width: 150,
                },

                {
                    title: "% Mujeres",
                    dataIndex: "porc_asistentesMujeresA",
                    key: "porc_asistentesMujeresA",
                    align: "center",
                    className: "ajustecolumna",
                    width: 100,
                },

            ],
        },



    ];


    // Función para abrir el modal y guardar el texto completo
    const openModal = (text) => {
        setFullText(text);
        setModalVisible(true);
    };



    // Función para manejar la edición
    const handleEdit = (record) => {
        // Llamamos a la función editRecord del formulario hijo
        modalRef.current.editRecord(record.rawData);
    };

    // Función para abrir en modo crear: llamada desde un botón
    const handleCreate = () => {
        // Usa optional chaining para evitar error si modalRef.current es null.
        modalRef.current?.showModal();
    };




  return (
  <div className="container">
    {/* Modal de registro */}
    <FormularioCohorte ref={modalRef} onRegistroGuardado={fetchData} />

    {/* Botones centrados */}
    <div className="d-flex justify-content-center gap-2 mb-4">
      <ExportToExcelCohortes data={data} indicadores={indicadores} />
      {modalRef.current?.permissionInsert && (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleCreate}
        >
          Registrar
        </Button>
      )}
    </div>
    <Table
      columns={columns}
      dataSource={data}
      pagination={{ pageSize: 15 }}
      bordered
      align="middle"
      scroll={{ x: "max-content" }}
    />

    {/* Modal de resumen */}
    <Modal
      title="Resumen del cohorte"
      open={modalVisible}
      onCancel={() => setModalVisible(false)}
      footer={null}
    >
      <div style={{ whiteSpace: "pre-line" }}>
        {fullText}
      </div>
    </Modal>
  </div>
);

};

export default Uniminuto;
